import { CommandType, } from "@buildwithflux/models";
import { values } from "lodash";
import { removeNodesAndDescendants, addPcbNodes as addPcbNodesToDocument } from "../../nodes";
import { withHistoryUpdate } from "../../project";
export const addPcbNodes = (snapshot, command, captureChangeUnitOfWorkOptions) => {
    const nodes = Array.isArray(command.nodes) ? command.nodes : values(command.nodes);
    // If captureChangeUnitOfWork is passed, craft and add changes to it
    if (captureChangeUnitOfWorkOptions) {
        const { uow, getListeners } = captureChangeUnitOfWorkOptions;
        const change = {
            command: CommandType.addPcbNodesCommand,
            kind: "subCollection",
            payload: {
                pcbLayoutNodes: {
                    set: nodes.map((node) => node.uid),
                },
            },
        };
        // For every node passed in because we are adding it, we need to
        // update both itself and its parent, so need to notify corresponding subscribers
        const allNodeUids = nodes.map((node) => node.uid);
        const updatedNodeUids = new Set([...allNodeUids, ...nodes.map((node) => node.parentUid)]);
        // Get all the listeners we want to notify right away
        const listeners = [
            // Notify subscribers subscribed to nodes
            ...getListeners({ target: "pcbNode", uids: Array.from(updatedNodeUids) }),
            // Notify subscribers subscribed to node's bakedRules
            ...getListeners({ target: "pcbNodeBakedRules", uids: allNodeUids }),
            ...getListeners({ target: "allPcbNodes" }),
        ];
        uow.addChange(change, listeners);
    }
    return withHistoryUpdate(snapshot, (draft) => {
        addPcbNodesToDocument(draft.pcbLayoutNodes, nodes, command.skipSort);
    });
};
export const updatePcbNodes = (snapshot, command, captureChangeUnitOfWorkOptions) => {
    const nodes = Array.isArray(command.nodes) ? command.nodes : values(command.nodes);
    // If captureChangeUnitOfWork is passed, craft and add changes to it
    if (captureChangeUnitOfWorkOptions) {
        const { uow, getListeners } = captureChangeUnitOfWorkOptions;
        const change = {
            command: CommandType.updatePcbNodesCommand,
            kind: "subCollection",
            payload: {
                pcbLayoutNodes: {
                    set: nodes.map((node) => node.uid),
                },
            },
        };
        // For every node passed in, because we are updating it, we only need to
        // update itself
        const nodeUids = nodes.map((node) => node.uid);
        // Get all the listeners we want to notify right away
        const listeners = [
            // Notify subscribers subscribed to nodes
            ...getListeners({ target: "pcbNode", uids: Array.from(nodeUids) }),
            // Notify subscribers subscribed to node's bakedRules
            ...getListeners({ target: "pcbNodeBakedRules", uids: nodeUids }),
            ...getListeners({ target: "allPcbNodes" }),
        ];
        uow.addChange(change, listeners);
    }
    return withHistoryUpdate(snapshot, (draft) => {
        addPcbNodesToDocument(draft.pcbLayoutNodes, nodes);
    });
};
export const removePcbNodes = (snapshot, command, captureChangeUnitOfWorkOptions) => {
    if (captureChangeUnitOfWorkOptions) {
        const { uow, getListeners } = captureChangeUnitOfWorkOptions;
        // Get all the listeners we want to notify right away
        const parentUids = Array.from(new Set(command.nodeUids
            .map((uid) => snapshot.pcbLayoutNodes[uid]?.parentUid)
            .filter((uid) => !!uid)));
        const listeners = [
            // Notify subscribers subscribed to nodes
            ...getListeners({ target: "pcbNode", uids: command.nodeUids }),
            // Notify subscribers subscribed to parents
            ...getListeners({ target: "pcbNode", uids: parentUids }),
            // Notify subscribers subscribed to all nodes
            ...getListeners({ target: "allPcbNodes" }),
        ];
        const change = {
            command: CommandType.removePcbNodesCommand,
            kind: "subCollection",
            payload: {
                pcbLayoutNodes: {
                    remove: command.nodeUids,
                },
            },
        };
        uow.addChange(change, listeners);
    }
    return withHistoryUpdate(snapshot, (newDocDraft) => {
        removeNodesAndDescendants(newDocDraft.pcbLayoutNodes, command.nodeUids);
    });
};
export const addPcbRuleSets = (snapshot, command) => {
    const ruleSets = Array.isArray(command.ruleSets) ? command.ruleSets : values(command.ruleSets);
    return withHistoryUpdate(snapshot, (newDocDraft) => {
        for (const ruleSet of ruleSets) {
            newDocDraft.pcbLayoutRuleSets[ruleSet.uid] = ruleSet;
        }
    });
};
export const updatePcbRuleSets = (snapshot, command) => {
    const ruleSets = Array.isArray(command.ruleSets) ? command.ruleSets : values(command.ruleSets);
    return withHistoryUpdate(snapshot, (newDocDraft) => {
        for (const ruleSet of ruleSets) {
            newDocDraft.pcbLayoutRuleSets[ruleSet.uid] = ruleSet;
        }
    });
};
export const removePcbRuleSets = (snapshot, command) => {
    return withHistoryUpdate(snapshot, (newDocDraft) => {
        for (const uid of command.ruleSetUids) {
            delete newDocDraft.pcbLayoutRuleSets[uid];
        }
    });
};
//# sourceMappingURL=pcb.js.map